import {AppState} from "../../redux";
import {HtmlPageProps} from "./html-page";
import { getBuiltInHtmlDocument } from "../../redux/cache/static-routes";

export const getMainPage = (state: AppState, props: HtmlPageProps) => {
  const { cacheKey } = props;
  if(!cacheKey) return null;
  const mainPage = state.cache.store[cacheKey] || getBuiltInHtmlDocument(cacheKey);
  return mainPage;
}
